module.exports = __webpack_public_path__ + "img/dtg-shirt.5133c155.svg";